import { Document } from './Document'
import { Format } from './Format'
import { Layout } from './Layout'
import { Script } from './Script'
import { Style } from './Style'

class Page extends Document {
  fields
  format
  images
  layout
  name
  number
  side
  style
  script
  previewUrl
  colorPrint
  cssVariables

  constructor (ref, data) {
    super(ref)

    this.fields = data.fields || data.data || {}
    this.format = new Format(data.format)
    this.images = data.images || {}
    this.layout = new Layout(data.template?.layout?.source ?? data.layout)
    this.name = data.name
    this.number = data.number || -1
    this.side = data.side
    this.style = new Style(data.template?.style?.source ?? data.style)
    this.script = new Script(data.template?.script?.source ?? data.script)
    this.previewUrl = data.previewUrl || undefined
    this.colorPrint = data.colorPrint
    this.template = data.template
    this.cssVariables = data.cssVariables ?? data.template?.cssVariables ?? []
  }

  render (contenteditable = false, rootEl) {
    this.#runPageScripts(rootEl)
    return this.layout.render(contenteditable, this.fields, this._id, this.colorPrint) + this.style.render(this._id, this.images, this.cssVariables)
  }

  toObject () {
    const data = super.toObject()
    data.format = JSON.parse(JSON.stringify(data.format))
    data.layout = data.layout.source
    data.style = data.style.source
    data.script = data.script.source ?? ''
    if (data.template) {
      data.template = data.template instanceof Page ? data.template._ref : data.template
    } else {
      delete data.template
    }
    // Firestore не принимает undefined (например, previewUrl у страниц без скриншота)
    Object.keys(data).forEach((key) => {
      if (data[key] === undefined) delete data[key]
    })
    return data
  }

  clone () {
    return new Page(this._ref, Object.assign(JSON.parse(this.toJSON()), { template: this.template }))
  }

  #runPageScripts (rootEl = document) {
    setTimeout(() => {
      rootEl.querySelectorAll(`.designer-workspace .page#${this._id}`)?.forEach((pageEl) => {
        this.script.render(this, pageEl)
      })
    })
  }
}

export { Page }
